import Select from 'react-select';
import React from 'react';

export const TeamMultiSelect = ({ teams, onChange, label, className }) => (
    <div className={className}>
        <span className={'input-label'}>{label}</span>
        <Select
            onChange={teamsOptions =>
                onChange(teamsOptions.map(option => option.value))
            }
            options={makeTeamOptions(teams)}
            isValidNewOption={() => false}
            isMulti
        />
    </div>
);

const makeTeamOptions = teams =>
    teams &&
    teams.map(team => ({
        label: `${team.name}`,
        value: team
    }));
